export const toSnakeCase = (text: string): string => {
  const result = text[0].toLowerCase() + text.substring(1);
  return result.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
};
